var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showTimeline)?[_c('Timeline')]:[_c('Default')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }